import { render, staticRenderFns } from "./StyleTypesDropdown.vue?vue&type=template&id=624785be"
import script from "./StyleTypesDropdown.vue?vue&type=script&lang=js"
export * from "./StyleTypesDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports